import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

import { isSP } from "./common/isSP.es6";

export default class ScrollFunc {
    constructor() {
        this.init();
    }

    init() {
        this.onScroll();
        this.smoothScroll();
    }

    onScroll() {
        const ribbonReveal = [...document.querySelectorAll(".js-ribbonreveal")];
        const revealElm = [...document.querySelectorAll(".js-scrollreveal")];

        ribbonReveal.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top 75%",
                //markers: true,
                onEnter: () => {
                    el.setAttribute("data-reveal", "1");
                },
            });
        });

        //書き文字Reveal
        const writingTxt = [...document.querySelectorAll(".js-writingtxt")];

        ScrollTrigger.create({
            trigger: document.querySelector(".mv__head__2a"),
            start: "top 75%",
            //markers: true,
            onEnter: () => {
                writingTxt.forEach((el) => el.setAttribute("data-anim", "1"));
            },
        });

        //PF Parallax
        const pfElements = [...document.querySelectorAll(".js-pfelements")];

        const offsetSettings = {
            wide: [20, 10],
            nrw: [10, 5],
        };

        pfElements.forEach((item) => {
            const offsetArr = isSP() ? offsetSettings.nrw : offsetSettings.wide;
            const offset = item.getAttribute("data-layer") === "1" ? offsetArr[0] : offsetArr[1];
            gsap.fromTo(
                item,
                { yPercent: offset },
                {
                    yPercent: -1 * offset,
                    scrollTrigger: {
                        trigger: item,
                        start: "top bottom",
                        end: "bottom top",
                        scrub: true,
                        onEnter: () => {
                            //gsap.fromTo(item, { opacity: 0, scale: 0 }, { opacity: 1, scale: 1, duration: 1 });
                        },
                    },
                }
            );
        });

        revealElm.forEach((el) => {
            ScrollTrigger.create({
                trigger: el,
                start: "top 85%",
                //markers: true,
                onEnter: () => {
                    el.setAttribute("data-reveal", "1");
                },
            });
        });
    }

    smoothScroll() {
        const triggers = [...document.querySelectorAll(".js-smoothscroll")];
        const pagetop = [...document.querySelectorAll(".js-pagetop")];

        triggers.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();
                const hash = el.getAttribute("href");
                const offset = 0;
                gsap.to(window, { duration: 1, scrollTo: { y: hash, offsetY: offset }, ease: "circ.inOut" });
            });
        });

        pagetop.forEach((el) => {
            el.addEventListener("click", (e) => {
                e.preventDefault();
                gsap.to(window, { duration: 1, scrollTo: { y: 0 }, ease: "circ.inOut" });
            });
        });
    }
}
